<template>
  <div class="mt-3">
    <v-row dense>
      <v-col cols="12" sm="6">
        <px-autocomplete-cadastro-adicional
          type="NATUREZA"
          label="Natureza"
          required
          :error="$v.formData.natureza.$error"
          @blur="$v.formData.natureza.$touch()"
          class="required rounded-tag-small"
          v-model="formData.natureza"/>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    formData: {
      type: Object,
      required: true,
    },
  },
  validations: {
    formData: {
      natureza: {
        required,
      },
    },
  },
};
</script>
